// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseQueryResult } from '@tanstack/react-query';
import { ClientOnboarderService } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/ClientOnboarder';
import { useModuleParty } from '../../../../contexts/ModuleContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useCustomPartyQuery } from '../../useOperatorBasedQuery';

const useClientOnboarderService: () => UseQueryResult<
  TemplateContract<ClientOnboarderService> | null,
  string
> = () => {
  const party = useModuleParty();
  return useCustomPartyQuery(
    'queryClientOnboarderService',
    party,
    (ledgerApi, offset, operator, p) => ledgerApi.queryClientOnboarderService(offset, operator, p),
  );
};

export default useClientOnboarderService;
